import React, { useEffect, useState } from 'react'
import './AirportMaster.css'
import { fetchAirportList } from '../../Api/Aiport'
import { AddUpdateAirport } from '../../Api/Aiport'
import { deleteAirport } from '../../Api/Aiport'
import Swal from 'sweetalert2'



const AirportMaster = () => {

    // Add Airport Form 

    const handleChange = (e) => {
        const { name, value } = e.target;

        setAirportForm((prev) => ({
            ...prev,
            [name]: value
        }));
    };

    //Add Airport ApI Function 
    const handleSubmit = async (e) => {
        e.preventDefault();

        const payload = {
            Id: airportForm.Id,
            AirportCode: airportForm.AirportCode,
            AirportName: airportForm.AirportName,
            City: airportForm.City,
            Country: airportForm.Country
        };

        try {
            await AddUpdateAirport(payload)
                .then(response => {
                    console.log("Add airport", response);
                    if (response?.Status === 200) {
                        Swal.fire({
                            title: "Success!",
                            text: isEdit ? "Airport updated successfully!" : "Airport added successfully!",
                            icon: "success",
                            confirmButtonText: "OK"
                        }).then(() => {
                            window.location.reload();
                        });
                
                    } else {
                        Swal.fire({
                            title: "Error!",
                            text: response?.Data || "Something went wrong",
                            icon: "error",
                            confirmButtonText: "OK"
                        });
                    }
                })
                .catch(error => {
                    console.error("Add Airport error: ", error);
                    Swal.fire({
                        title: "Error!",
                        text: isEdit ? "Failed to update airport" : "Failed to add airport",
                        icon: "error",
                        confirmButtonText: "OK"
                    });
                });


            setAirportForm({
                AirportCode: "",
                AirportName: "",
                City: "",
                Country: ""
            });
            
        } catch (error) {
            console.error("Add Airport failed", error);
        }
    
    };
    const [airportForm, setAirportForm] = useState({
        Id: 0,
        AirportCode: "",
        AirportName: "",
        City: "",
        Country: ""
    });

    // State for airport list
    const [airportListRequest, setAirportListRequest] = useState({
        PageNo: 1,
        PageSize: 50,
        SortBy: "",
        AirportName: "",
        AirportCode: ""
    });

    const [airportList, setAirportList] = useState([]);
    const [showForm, setShowForm] = useState(false);
    const [isEdit, setisEdit] = useState(false)

            useEffect(() => {
                fetchAirportList(airportListRequest)
                    .then(response => {
                        setAirportList(response.Data || []);
                    })
                    .catch(error => {
                        console.error("Error fetching airport list:", error);
                    });
            }, [airportListRequest]);

    const handleNext = () => {
        setAirportListRequest(prev => ({
            ...prev,
            PageNo: prev.PageNo + 1
        }));
    };

    const handlePrev = () => {
        setAirportListRequest(prev => ({
            ...prev,
            PageNo: Math.max(prev.PageNo - 1, 1)
        }));
    };


    const handleDelete = async (airportId) => {
        Swal.fire({
            title: "Are you sure?",
            text: "You won't be able to revert this!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, delete it!",
            cancelButtonText: "Cancel"
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    await deleteAirport(airportId)  
                        .then(response => {
                            console.log("delete airport", response);
                            if (response?.Status === 200) {
                                Swal.fire({
                                    title: "Deleted!",
                                    text: "Airport deleted successfully!",
                                    icon: "success",
                                    confirmButtonText: "OK"
                                }).then(() => {
                                    window.location.reload();
                                });
                            } else {
                                Swal.fire({
                                    title: "Error!",
                                    text: response?.Message || "Failed to delete airport.",
                                    icon: "error",
                                    confirmButtonText: "OK"
                                });
                            }
                        })
                        .catch(error => {
                            console.error("Delete Airport error: ", error);
                            Swal.fire({
                                title: "Error!",
                                text: "Failed to delete airport",
                                icon: "error",
                                confirmButtonText: "OK"
                            });
                        });

                    setAirportForm({
                        AirportCode: "",
                        AirportName: "",
                        City: "",
                        Country: ""
                    });
                } catch (error) {
                    console.error("Add Airport failed", error);
                }
            }
            // If cancelled, do nothing
        });
        return;
      
    };



    return (
        <>
            {showForm &&
                <div className="container-fluid bg-white p-4 border mb-4" style={{ boxShadow: "0 2px 8px rgba(0,0,0,0.10)", borderRadius: "16px" }}>
                    <div className="d-flex justify-content-between align-items-center mb-4">
                        <h6 className="section-1-title mb-0 text-start">
                        {isEdit ? "Update Airport" : "Add Airport"}
                        </h6>

                        <button
                            type="button"
                            className="btn"
                            onClick={() => setShowForm(false)}
                            title="Close"

                        >
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-lg" viewBox="0 0 16 16">
                                <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8z" />
                            </svg>
                        </button>
                    </div>
                    <form onSubmit={handleSubmit}>
                        <div className="row g-3">
                            <div className="col-md-3">
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Airport Code"
                                    name="AirportCode"
                                    value={airportForm.AirportCode}
                                    onChange={handleChange}
                                />
                            </div>

                            <div className="col-md-3">
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Airport Name"
                                    name="AirportName"
                                    value={airportForm.AirportName}
                                    onChange={handleChange}
                                />
                            </div>

                            <div className="col-md-3">
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="City"
                                    name="City"
                                    value={airportForm.City}
                                    onChange={handleChange}
                                />
                            </div>

                            <div className="col-md-3">
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Country Name"
                                    name="Country"
                                    value={airportForm.Country}
                                    onChange={handleChange}
                                />
                            </div>

                            <div className="col-12 mt-3 text-start">
                                <button type="submit" className="Save-btn">
                                {isEdit ? "Update Airport" : "Save"}
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            }

            <div className="bg-white" style={{ borderRadius: '16px', boxShadow: "0 2px 8px rgba(0,0,0,0.10)" }}>
                {/* Section Header */}
                <div className="d-flex flex-column flex-sm-row justify-content-between align-items-center p-4 gap-2">
                    {/* Title */}
                    <div className="section-1-title align-self-start">
                        Airport List
                    </div>

                    {/* Header Buttons */}
                    <div className="d-flex flex-row flex-sm-col gap-2 gap-sm-1 section-header-buttons w-sm-auto">
                        <div className="d-flex gap-2">
                            {/* Sort */}
                            {/* <button className="btn btn-light rounded-circle d-flex align-items-center justify-content-center circular-btn">
            <img src="assets/icons/sort icon.svg" alt="Sort" />
          </button> */}

                            {/* Filter */}
                            {/* <button className="btn btn-light rounded-circle d-flex align-items-center justify-content-center circular-btn">
                                <img src="./assest/Images/filter.png" alt="Filter" />
                            </button> */}
                        </div>

                        {/* Create New */}
                        <button
                            className="ms-auto create-new-btn p-2 rounded-5"
                            onClick={() => setShowForm(prev => !prev)}
                        >
                            {showForm ? "✖ Close" : "+ Create New"}
                        </button>
                    </div>
                </div>

                {/* Search */}
                <div className="px-4 pb-3">
                    <input
                        className="search-bar rounded-3"
                        type="search"
                        placeholder="Search Airport"
                    />
                </div>

                {/* Airport Table */}   
                <div className="px-3  pb-4 table-responsive custom-scroll">
                    <table className="table p-2 table-borderless data-table">
                        <thead style={{ 
                fontFamily: "Poppins", 
                backgroundColor: "#F8F9FF", 
                borderWidth: "1px 0px 1px 0px",
                borderStyle: "solid",
                borderColor: "#0000001A",   

              }}>
                            <tr>
                                <th className="table-field-bg-color" style={{paddingLeft:"25px"}}>S. No.</th>
                                <th className="table-field-bg-color">Airport Code</th>
                                <th className="table-field-bg-color airport-name-col">Airport Name</th>
                                <th className="table-field-bg-color">City</th>
                                <th className="table-field-bg-color">Country</th>
                                <th className="table-field-bg-color text-center">Actions</th>
                            </tr>
                        </thead>

                        <tbody style={{overflow:"scroll",textAlign:"left"}}>
                            {airportList.items && airportList.items.length > 0 ? (
                                airportList.items.map((airport) => (
                                    <tr key={airport.Id} style={{height:"10px",borderBottom: "1px solid #0000001A", verticalAlign:"middle"}}>
                                        <td style={{paddingLeft:"25px"}}>{airport.rno}</td>
                                        <td>{airport.AirportCode}</td>
                                        <td className='airport-name-col'>{airport.AirportName}</td>
                                        <td>{airport.City}</td>
                                        <td>{airport.Country}</td>
                                        <td className="text-center">
                                            <button
                                                className="btn bg-light btn-sm me-2"
                                                title="Edit"
                                                onClick={() => {
                                                    setShowForm(true);       // show form
                                                    setisEdit(true);        // mark edit mode
                                                    setAirportForm({
                                                        Id: airport.Id,
                                                        AirportCode: airport.AirportCode,
                                                        AirportName: airport.AirportName,
                                                        City: airport.City,
                                                        Country: airport.Country,
                                                    });
                                                }}
                                            >
                                                <img src="./assest/Images/Edit.png" alt="Edit" style={{ width: "1rem" }} />
                                            </button>
                                            <button
                                                className="btn bg-light btn-sm"
                                                title="Delete"
                                                onClick={() => handleDelete(airport.Id)}
                                            >
                                                <img src="./assest/Images/delete.png" alt="Delete" style={{ width: "1rem" }} />
                                            </button>
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan={6} className="text-center">No airports found.</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>

            {/* Pagination */}

            <div className="d-flex justify-content-between align-items-center px-4 py-3">
                <span>
                    Page {Math.min(airportList.metaData?.currentPage || airportListRequest.PageNo, airportList.metaData?.totalPages || 1)} of {airportList.metaData?.totalPages || 1}
                    </span>

                <div className="d-flex gap-2">
                    <button
                        className="btn btn-light btn-sm"
                        onClick={handlePrev}
                        disabled={airportListRequest.PageNo === 1}
                    >
                        Prev
                    </button>

                    <button
                        className="btn btn-light btn-sm"
                        onClick={handleNext}
                    disabled={
                        (airportList.metaData?.currentPage || airportListRequest.PageNo)
                        ===
                        (airportList.metaData?.totalPages || 1)
                    }   
                    >
                        Next
                    </button>
                </div>
            </div>
        </>
    )
}

export default AirportMaster